import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "./pdfstyle.css";
import {
  FaRegArrowAltCircleRight,
  FaRegArrowAltCircleLeft,
} from "react-icons/fa";
import { PDFDocument } from "pdf-lib";
import { useLocation, useNavigate } from "react-router-dom";
import { FiZoomIn } from "react-icons/fi";
import { FiZoomOut } from "react-icons/fi";
import { all_routes } from "../router/all_routes";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewer = () => {
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [lastPageChange, setLastPageChange] = useState(Date.now());
  const [analytics, setAnalytics] = useState([]);
  const [scale, setScale] = useState(1.0);
  const [pageDimensions, setPageDimensions] = useState(null);
  const [pdfToShow, setPdfToShow] = useState("");
  const [viewportSize, setViewportSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const navigate = useNavigate();
  const routes = all_routes;

  useEffect(() => {
    const handleResize = () => {
      setViewportSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const location = useLocation();
  const [row, setRow] = useState(null);
  const [school_code, setSchool_code] = useState("");
  const storedRow = JSON.parse(localStorage.getItem("pdfData") || "null");
  // const [row, setRow] = useState(null);
  // const [school_code, setSchool_code] = useState("");

  useEffect(() => {
    if (storedRow) {
      setRow(storedRow);
      setSchool_code(localStorage.getItem("schoolCode"));
    }
  }, []);

  const onFileChange = (e) => {
    // e.preventDefault();
    const uploadedFile = e.target.files[0];
    if (uploadedFile?.type === "application/pdf") {
      const reader = new FileReader();
      reader.onload = function (event) {
        const fileUrl = event.target.result;
        const fileData = { lesson_pdf_path: fileUrl };
        localStorage.setItem("pdfData", JSON.stringify(fileData));
        setRow(fileData);
        setPageNumber(1);
      };
      reader.readAsDataURL(uploadedFile);
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLastPageChange(Date.now());
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= numPages) {
      setPageNumber(newPage);
    }
  };

  const endSession = () => {
    alert("Session Completed!");
    navigate(routes.training);
    // navigate(routes.selectUnit);
  };

  // console.log(row);

  return (
    <div className="page-wrapper mt-4 px-2 px-md-4">
      <div className="d-flex ">
        <button className="complete-session-btn ms-auto" onClick={endSession}>
          Complete Session
        </button>
      </div>

      {/* <input type="file" accept="application/pdf" onChange={onFileChange} /> */}

      <div className="pdf-wrapper rounded-1 mt-3 position-relative">
        <Document
          file={row?.lesson_pdf_path}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page
            pageNumber={pageNumber}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            onLoadSuccess={(page) => {
              setPageDimensions({ width: page.width, height: page.height });
            }}
            {...(pageDimensions
              ? pageDimensions.height / pageDimensions.width > 1.2
                ? { height: viewportSize.height * 0.9 * scale }
                : { width: viewportSize.width * 0.95 * scale }
              : { width: viewportSize.width * 0.95 * scale })}
          />
        </Document>

        <div className="bottom-bar justify-content-center w-100 ">
          <div className="page-indicator">
            {pageNumber} / {numPages}
          </div>
          <div className="zoom-controls d-flex justify-content-center align-items-center">
            <FiZoomIn
              onClick={() => setScale((prev) => Math.min(prev + 0.1, 3))}
              size={36}
              className="zoom-icon"
            />
            <FiZoomOut
              onClick={() => setScale((prev) => Math.max(prev - 0.1, 0.5))}
              size={36}
              className="zoom-icon"
            />
          </div>
        </div>
        {/* </div> */}

        <div className="">
          <FaRegArrowAltCircleLeft
            className="nav-arrow left-arrow "
            size={44}
            onClick={() => handlePageChange(pageNumber - 1)}
            style={{
              pointerEvents: pageNumber <= 1 ? "none" : "auto",
              opacity: pageNumber <= 1 ? 0.4 : 1,
            }}
          />

          <FaRegArrowAltCircleRight
            className="nav-arrow right-arrow"
            size={44}
            onClick={() => handlePageChange(pageNumber + 1)}
            style={{
              pointerEvents: pageNumber >= numPages ? "none" : "auto",
              opacity: pageNumber >= numPages ? 0.4 : 1,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PdfViewer;
